'use strict';
// Android >=12.10.0

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function clientShare() {
  var pkgName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'com.whatsapp';
  var content = arguments[1];

  return new _promise2.default(function (resolve, reject) {
    if (!window.ucapi || !window.ucapi.invoke) return;
    window.ucapi.invoke('biz.share', {
      package: pkgName, // 分享目标包名【必填】，如com.whatsapp
      content: content, // 分享内容【必填】，文本或链接
      from: '', // 来源【可选】，客户端wa统计使用
      success: function success(data) {
        if (data.msg === 'package error') {
          reject(data);
        } else {
          resolve(data);
        }
      },
      fail: function fail(data) {
        reject(data);
        // 参数错误：params error
        // 没有安装：package error
      }
    });
  });
};